import { useState, useEffect } from "react";

/**
 * 화면 너비 기준 모바일 여부 판단 훅.
 * 기존 캘린더/태스크 페이지의 분기 방식과 동일하게 사용.
 *
 * @param {number} breakpoint - 이 값(px) 미만이면 모바일로 간주 (기본 768)
 * @returns {boolean} isMobile
 */
export default function useIsMobile(breakpoint = 768) {
  const getMatch = () =>
    typeof window !== "undefined" && window.innerWidth < breakpoint;

  const [isMobile, setIsMobile] = useState(getMatch);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);

    // 초기 동기화
    setIsMobile(mql.matches);

    // addEventListener 미지원 구형 브라우저 호환
    if (mql.addEventListener) mql.addEventListener("change", handler);
    else mql.addListener(handler);

    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", handler);
      else mql.removeListener(handler);
    };
  }, [breakpoint]);

  return isMobile;
}